import React from 'react'

class About extends React.Component {
    render(){
        return(
            <div>
                <h1>Halaman About</h1>
            </div>
        )
    }
}

export default About